import { api } from './_barrel.js';

        // =======================================================================
        // Configuration — edit these to match your environment
        // =======================================================================
        const CONFIG = {
            auth0Domain: 'dev-o8c5fcidbvaqj5j4.uk.auth0.com',
            auth0ClientId: 'qY99wdS4z7Lh84D5LQp0BaZ3Rvu4Te64',
            auth0Audience: 'https://api.obsidianveil.app',
            auth0OrgId: 'org_7JEzk4o3uxsno1bF',
            apiBase: window.location.origin,
        };

export { CONFIG };
